export { en } from './en';
export type { Catalogue, CatalogueKey } from './en';
export { ml } from './ml';

export const LANGUAGES = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'ml', label: 'മലയാളം', name: 'Malayalam' },
] as const;
export type LanguageCode = (typeof LANGUAGES)[number]['code'];
